import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reviewTime: {
		id: 'software-cycle-time-breakdown-report.issue-chart.chart.tooltip.review-time',
		defaultMessage: 'review time',
		description: 'To be joined with a duration e.g. 1 day 2 hrs review time',
	},
});
